import type { EngagementTileData } from '@/components/contacts/EngagementTile'

export interface EngagementHeadline {
  label: string
  window_label: string
  lapsed_banner: string | null
  empty_message: string | null
  tiles: EngagementTileData[]
}
type Figure = number | { formatted: string } | null
interface Period {
  label: string
  starts_on: string
  ends_on: string
}
export interface OrganizationEngagement {
  headline: EngagementHeadline | null
  window: {
    segment_labels: [string, string]
    current: Period | null
    same_point_previous?: Period | null
    whole_previous: Period | null
    comparison_label: string
  }
  permitted_tiles: string[]
  tiles: Record<
    string,
    {
      current: Figure
      whole_previous: Figure
      capacity?: number
      whole_previous_sent_people?: number | null
    }
  >
}
export const stateLabels = {
  roster: 'Roster filled',
  personal_memberships: 'Personal memberships',
  groups: 'Groups',
}
export const windowedKeys = ['spend', 'event_registrations', 'courses_completed', 'email_clicks']
export function formattedFigure(value: Figure) {
  if (value === null) return '—'
  return typeof value === 'object' ? value.formatted : String(value)
}
export function engagementHref(key?: string, tab = 'engagement') {
  const url = new URL(window.location.href)
  url.searchParams.set('tab', tab)
  url.searchParams.delete('window')
  if (key) url.searchParams.set('tile', key)
  else url.searchParams.delete('tile')
  return `${url.pathname}${url.search}${url.hash}`
}

export function previousFigure(tile: OrganizationEngagement['tiles'][string]) {
  const figure = formattedFigure(tile.whole_previous)
  return tile.whole_previous_sent_people == null
    ? figure
    : `${figure} of ${tile.whole_previous_sent_people}`
}
